<template>
  <div>
    <el-dialog
      ref="allotDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="h720_dialog abow_dialog"
      width="1100px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      @open="handleOpen('allotDialog')"
    >
      <div
        v-loading="loading"
        :loading="loading"
        :element-loading-text="loadingText"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <el-form
          ref="dialogAllotForm"
          :model="dialogAllotForm"
          :rules="dialogAllotFormRules"
          class="add-edit-view-form"
          @submit.native.prevent
        >
          <div class="modal-box">
            <h3 class="modal-title">
              调拨信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="12">
                  <el-form-item
                    label="管理人员(调入)"
                    prop="toManagerId"
                  >
                    <el-select
                      v-model="dialogAllotForm.toManagerId"
                      filterable
                      clearable
                      placeholder="请选择接收调入固定资产的管理人员"
                      style="width:100%"
                      @change="toManagerChangeFun"
                    >
                      <el-option
                        v-for="item in userOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-col :span="24">
                  <el-form-item
                    label="调拨情况说明"
                    prop="allotRemark"
                  >
                    <el-input
                      v-model="dialogAllotForm.allotRemark"
                      type="textarea"
                      placeholder="请输入调拨情况说明"
                      show-word-limit
                      maxlength="128"
                      rows="3"
                      style="margin-top: -8px;"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>

          <div class="modal-box">
            <h3 class="modal-title">
              调拨的固定资产清单
              <el-button
                plain
                size="mini"
                icon="el-icon-circle-plus-outline"
                style="float:right; margin-top:0.1em; margin-right:15px;"
                @click="addAllotAssetFun"
              >
                添加调拨的固定资产
              </el-button>
            </h3>
            <div
              class="modal-row-box"
              style="height: 340px;"
            >
              <el-table
                :data="dialogAllotForm.allotFixedAssetData"
                style="width: 100%; display: inline-block;"
                :header-cell-style="{background:'#0076ff'}"
                border
                max-height="330"
              >
                <el-table-column
                  type="index"
                  label="序号"
                  width="60"
                  align="center"
                />
                <el-table-column
                  label="管理人员"
                  header-align="center"
                  width="200"
                >
                  <template slot-scope="scope">
                    <el-form-item
                      :prop="'allotFixedAssetData.' + scope.$index + '.managerId'"
                      :rules="dialogAllotFormRules.managerId"
                    >
                      <el-select
                        v-model="scope.row.managerId"
                        filterable
                        clearable
                        placeholder="请选择调出管理人员"
                        style="width:100%"
                        @change="managerChangeFun(scope.row, $event)"
                      >
                        <el-option
                          v-for="item in managerOptions"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        />
                      </el-select>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column
                  label="固定资产"
                  header-align="center"
                >
                  <template slot-scope="scope">
                    <el-form-item
                      :prop="'allotFixedAssetData.' + scope.$index + '.id'"
                      :rules="dialogAllotFormRules.id"
                    >
                      <el-select
                        v-model="scope.row.id"
                        filterable
                        clearable
                        placeholder="请选择调拨的固定资产"
                        style="width:100%"
                        @change="fixedAssetChangeFun(scope.row, $event)"
                      >
                        <el-option
                          v-for="item in scope.row.fixedAssetOptions"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"
                        />
                      </el-select>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="unit"
                  label="计量单位"
                  align="center"
                  width="80"
                />
                <el-table-column
                  prop="manageNumber"
                  label="管理数量"
                  align="center"
                  width="120"
                />
                <el-table-column
                  prop="lentNumber"
                  label="借出数量"
                  align="center"
                  width="120"
                />
                <el-table-column
                  prop="allotNumber"
                  label="调拨数量"
                  align="center"
                  width="140"
                >
                  <template slot-scope="scope">
                    <el-form-item>
                      <el-form-item
                        :prop="'allotFixedAssetData.' + scope.$index + '.allotNumber'"
                        :rules="dialogAllotFormRules.allotNumber"
                      >
                        <el-input v-model="scope.row.allotNumber" />
                      </el-form-item>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column
                  label="操作"
                  width="60"
                  align="center"
                >
                  <template slot-scope="scope">
                    <i
                      class="el-icon-delete"
                      style="color: red; font-size: 16px;"
                      @click="handleDeleteAllotAsset(scope.$index)"
                    />
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </el-form>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          type="primary"
          :disabled="operateButtonDisable"
          @click="handleSave"
        >
          保存
        </el-button>
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>

// dialog 拖拽dialogDragMixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 设置input值为数字
import setNumberMixin from '@/mixin/setNumberMixin'
// 数据请求
import { allotFixedAssetApi, loadSelectManagerDataApi, loadManageFixedAssetDataApi } from '@/api/fixedAsset'
import { loadUserSelectDataByUserRegionIdsApi } from '@/api/user'

export default {
  components: {},
  mixins: [dialogDragMixin, setNumberMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    eventType: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    // 调出固定资产人员
    const validateManager = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请选择要调出出固定资产的管理人员'))
      } else if (this.dialogAllotForm.toManagerId && value === this.dialogAllotForm.toManagerId) {
        callback(new Error('调入和调出固定资产的管理人员不能是同一人'))
      } else {
        callback()
      }
    }
    // 调拨数量
    const validateAllotNumber = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入要调拨的数量'))
      } else if (Number(value) === 0) {
        callback(new Error('固定资产调拨数量不能为0'))
      } else if (!/^(0|([1-9][0-9]*))(\.[\d]{1,2})?$/.test(value)) {
        callback(new Error('请输入数字格式的内容，允许输入内容为：2位小数'))
      } else {
        callback()
      }
    }
    return {
      operateButtonDisable: false,
      loading: false,
      loadingText: '努力加载数据中，请耐心等待',

      dialogAllotForm: {},
      dialogAllotFormRules: {
        managerId: [{ required: true, validator: validateManager, trigger: 'change' }],
        toManagerId: [{ required: true, message: '请选择接收调入固定资产的管理人员', trigger: 'change' }],
        id: [{ required: true, message: '请选择要调拨的固定资产', trigger: 'change' }],
        allotNumber: [{ required: true, validator: validateAllotNumber, trigger: 'blur' }]
      },
      userOptions: [],
      managerOptions: []
    }
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        let _this = this
        _this.loading = true
        _this.loadingText = '努力加载数据中，请耐心等待'
        _this.operateButtonDisable = false

        _this.userOptions = []
        _this.managerOptions = []
        _this.dialogAllotForm = {
          toManagerId: '',
          toManagerName: '',
          allotRemark: '',
          allotFixedAssetData: [],
          allotFixedAssetJson: ''
        }
        // 获取管理人员选项数据
        _this.initManagerSelectData()
        // 获取接收调入资产的人员选项数据
        _this.initUserSelectData()

        _this.$nextTick(() => {
          _this.loading = false
          _this.$refs.dialogAllotForm.clearValidate()
        })
      }
    }
  },
  methods: {
    // 获取接收调入资产的人员选项数据
    initUserSelectData() {
      let _this = this;
      loadUserSelectDataByUserRegionIdsApi().then(response => {
        response.data.forEach(item => {
          _this.userOptions.push({ label: item.name, value: item.id })
        })
      })
    },
    // 接收调入资产的人员选择回调
    toManagerChangeFun(val) {
      let _this = this
      let selectedItem = {}
      if (val) {
        selectedItem = _this.userOptions.find(item => {
          return item.value === val
        })
      }
      _this.dialogAllotForm.toManagerName = selectedItem.label || ''
    },
    // 初始管理人员选项数据
    initManagerSelectData() {
      let _this = this;
      loadSelectManagerDataApi().then(response => {
        response.data.forEach(item => {
          _this.managerOptions.push({ label: item.managerName, value: item.managerId })
        })
      })
    },
    // 管理人员选择回调
    managerChangeFun(row, val) {
      row.fixedAssetOptions = [];
      if (val) {
        loadManageFixedAssetDataApi({ managerId: val }).then(response => {
          row.fixedAssetOptions = response.data || []
        })
      }
    },
    // 添加调拨的固定资产
    addAllotAssetFun() {
      let _this = this
      _this.dialogAllotForm.allotFixedAssetData.push({
        managerId: '',
        managerName: '',
        fixedAssetOptions: [],
        id: '',
        name: '',
        unit: '',
        materialsId: 0,
        manageNumber: 0,
        lentNumber: 0,
        ableAllotNumber: 0,
        allotNumber: 0
      })
    },
    // 删除调拨的固定资产
    handleDeleteAllotAsset(index) {
      this.dialogAllotForm.allotFixedAssetData.splice(index, 1)
    },
    // 调拨的固定资产选择回调
    fixedAssetChangeFun(row, val) {
      let selectedAsset = {}
      selectedAsset = row.fixedAssetOptions.find(item => {
        return item.id === val
      })
      row.managerName = selectedAsset ? selectedAsset.managerName : ''
      row.name = selectedAsset ? selectedAsset.name : ''
      row.unit = selectedAsset ? selectedAsset.unit : ''
      row.materialsId = selectedAsset ? selectedAsset.materialsId : 0
      row.manageNumber = selectedAsset ? selectedAsset.manageNumber : 0
      row.lentNumber = selectedAsset ? selectedAsset.lentNumber : 0
      row.ableAllotNumber = selectedAsset ? this.roundNumber(Number(selectedAsset.manageNumber) - Number(selectedAsset.lentNumber)) : 0
    },
    // 加载数据
    reloadData() {
      this.$emit('reloadData')
    },
    modalClose() {
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
      this.$refs.dialogAllotForm.clearValidate()
    },
    // 新增|修改保存
    handleSave() {
      let _this = this
      _this.$refs.dialogAllotForm.validate(valid => {
        if (valid) {
          if (_this.dialogAllotForm.allotFixedAssetData.length === 0) {
            _this.$message({ message: '未录入要调拨的固定资产信息，不能保存', type: 'warning' })
            return false
          }
          // 验证调拨的固定资产是否存在重复的
          let fixedAssetCountMap = new Map()
          let fixedAssetNameMap = new Map()
          let managerNameMap = new Map()
          let allotNumberErrorArray = []
          _this.dialogAllotForm.allotFixedAssetData.forEach(item => {
            let assetId = item.id
            let existCount = 1
            if (fixedAssetCountMap.get(assetId)) {
              existCount = existCount + fixedAssetCountMap.get(assetId)
            }
            fixedAssetCountMap.set(assetId, existCount)
            managerNameMap.set(assetId, item.managerName)
            fixedAssetNameMap.set(assetId, item.name)
            // 严重调拨数量是否超过允许调拨数量
            if (Number(item.allotNumber) > Number(item.ableAllotNumber)) {
              allotNumberErrorArray.push(item)
            }
          })
          for (var [key, value] of fixedAssetCountMap) {
            if (value > 1) {
              _this.$message({ message: '管理人员:' + managerNameMap.get(key) + ' 固定资产:' + fixedAssetNameMap.get(key) + ' 重复存在，请删除重复项', type: 'warning' })
              return false
            }
          }
          for (var numberError of allotNumberErrorArray) {
            _this.$message({ message: '管理人员:' + numberError.managerName + ' 固定资产:' + numberError.name + ' 最多允许调拨数量：' + numberError.ableAllotNumber, type: 'warning' })
            return false
          }

          _this.dialogAllotForm.allotFixedAssetJson = JSON.stringify(_this.dialogAllotForm.allotFixedAssetData)
          _this.$confirm('是否确定保存调拨内容', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }).then(async () => {
            allotFixedAssetApi(_this.dialogAllotForm).then(res => {
              _this.$message({ message: res.message, type: 'success' })
              _this.reloadData()
              _this.modalClose()
            }).catch(() => {
              _this.loading = false
              _this.operateButtonDisable = false
            })
          }).catch(() => { })
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.el-table--border {
  border-left: 1px solid #dfe6ec;
  margin-top: 5px;
}
::v-deep .el-table {
  th {
    color: #ffffff;
    .cell {
      line-height: 17px;
    }
    .caret-wrapper {
      height: 18px;
    }
    .sort-caret {
      border-width: 4px;
      &.ascending {
        top: 0;
      }
      &.descending {
        bottom: 0;
      }
    }
  }
  .ascending .sort-caret.ascending {
    border-bottom-color: #ffffff;
  }
  .descending .sort-caret.descending {
    border-top-color: #ffffff !important;
  }
}
::v-deep .el-table--mini th,
::v-deep .el-table--mini td {
  padding: 4px;
  font-size: 12px;
  .cell {
    line-height: 16px;
  }
}

::v-deep .el-table__row {
  .el-form-item__error {
    display: none;
  }
  .el-form-item--mini.el-form-item {
    margin-bottom: 0px;
  }
}
</style>
